import fetch from 'isomorphic-fetch';
import { EventTypes } from 'redux-segment';
import * as ActionType from './types/AuthActionTypes';
import { getUserContext, identifyUser } from './UserActions';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

function accountCreated() {
  return {
    type: 'ACCOUNT_CREATED',
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'user_created'
        }
      }
    }
  };
}

export function loginSuccess() {
  return {
    type: ActionType.LOGIN_SUCCESS,
    payload: {}
  };
}

export function loginFailure(error) {
  return {
    type: ActionType.LOGIN_FAILURE,
    payload: {
      status: error.response.status,
      statusText: error.response.statusText
    }
  };
}

export function loginRequest() {
  return {
    type: ActionType.LOGIN_REQUEST
  };
}

export function logout() {
  return {
    type: ActionType.LOGOUT
  };
}

export function login(loginFormRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return fetch('/web-api/v1/auth/login',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginFormRequest)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((responseJson) => {
        dispatch(getUserContext()).then(() => {
          dispatch(identifyUser());
        });
        return responseJson;
      });
  };
}

export function facebookLogin(fbLoginRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return fetch('/web-api/v1/auth/facebook-login',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(fbLoginRequest)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((responseJson) => {
        dispatch(getUserContext()).then(() => {
          dispatch(identifyUser());
        });
        return responseJson;
      });
  };
}

export function signout() {
  return dispatch => (
    fetch('/web-api/v1/auth/signout',
      {
        credentials: 'same-origin',
      })
      .then(dispatch(logout()))
  );
}

export function signup(createUserRequest) {
  return (dispatch) => {
    dispatch(loginRequest());
    return fetch('/web-api/v1/user/create',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(createUserRequest)
      })
      .then(handleErrors)
      .then(() => {
        dispatch(getUserContext()).then(() => {
          dispatch(identifyUser());
          dispatch(accountCreated());
        });
      });
  };
}

export function checkEmail(email) {
  return () => (
    fetch(`/web-api/v1/user/email_available/${email}`,
      {
        method: 'POST',
        credentials: 'same-origin',
      })
      .then(handleErrors)
      .then(response => response.json())
  );
}

export function sendResetPassword(email) {
  return () => (
    fetch(`/web-api/v1/user/reset_password/${email}`,
      {
        method: 'POST',
        credentials: 'same-origin',
      })
      .then(handleErrors)
      .then(response => response.json())
  );
}



/** WEBPACK FOOTER **
 ** ./src/actions/AuthActions.js
 **/